
// 🛑 This file is auto-generated by generate-icon-map.js
import Icon0 from './cause/animal_welfare.svg';
import Icon1 from './cause/anti_racism.svg';
import Icon2 from './cause/armed_forces_charities.svg';
import Icon3 from './cause/autism.svg';
import Icon4 from './cause/bird_protection.svg';
import Icon5 from './cause/cancer_charities.svg';
import Icon6 from './cause/charity_regulation.svg';
import Icon7 from './cause/childrens_charities.svg';
import Icon8 from './cause/climate_change.svg';
import Icon9 from './cause/countryside.svg';
import Icon10 from './cause/diabetes_charities.svg';
import Icon11 from './cause/disability.svg';
import Icon12 from './cause/dog_welfare.svg';
import Icon13 from './cause/fairtrade.svg';
import Icon14 from './cause/feminism.svg';
import Icon15 from './cause/gardens.svg';
import Icon16 from './cause/homelessness.svg';
import Icon17 from './cause/human_rights.svg';
import Icon18 from './cause/legal_rights.svg';
import Icon19 from './cause/lgbtq_diversity.svg';
import Icon20 from './cause/lifeboats_and_coastguards.svg';
import Icon21 from './cause/mental_health.svg';
import Icon22 from './cause/ms_charities.svg';
import Icon23 from './cause/national_development.svg';
import Icon24 from './cause/nature_protection.svg';
import Icon25 from './cause/ocean_protection.svg';
import Icon26 from './cause/old_people_supporters.svg';
import Icon27 from './cause/pet_protection.svg';
import Icon28 from './cause/planet_protection.svg';
import Icon29 from './cause/recycling_and_plastic_free.svg';
import Icon30 from './cause/refugees_and_equality.svg';
import Icon31 from './cause/renewable_energy.svg';
import Icon32 from './cause/the_environment.svg';
import Icon33 from './cause/tv_fundraising.svg';
import Icon34 from './cause/vegan_lifestyle.svg';
import Icon35 from './cause/veganism.svg';
import Icon36 from './cause/world_aid.svg';
import Icon37 from './cause/world_wildlife.svg';
import Icon38 from './default.svg';
import Icon39 from './interest/academia.svg';
import Icon40 from './interest/accountancy.svg';
import Icon41 from './interest/action.svg';
import Icon42 from './interest/action_and_adventure_games.svg';
import Icon43 from './interest/alcohol.svg';
import Icon44 from './interest/american_football.svg';
import Icon45 from './interest/animal_charities.svg';
import Icon46 from './interest/animation_and_cartoons.svg';
import Icon47 from './interest/anime.svg';
import Icon48 from './interest/antiques.svg';
import Icon49 from './interest/architecture.svg';
import Icon50 from './interest/art.svg';
import Icon51 from './interest/art_and_design.svg';
import Icon52 from './interest/asian_pop_music.svg';
import Icon53 from './interest/athletics.svg';
import Icon54 from './interest/award_shows.svg';
import Icon55 from './interest/baking.svg';
import Icon56 from './interest/baseball.svg';
import Icon57 from './interest/basketball.svg';
import Icon58 from './interest/beauty.svg';
import Icon59 from './interest/beer_and_cider.svg';
import Icon60 from './interest/bird_and_wildlife_spotting.svg';
import Icon61 from './interest/blues_music.svg';
import Icon62 from './interest/boats.svg';
import Icon63 from './interest/body_building_and_weightlifting.svg';
import Icon64 from './interest/bollywood.svg';
import Icon65 from './interest/books_and_literature.svg';
import Icon66 from './interest/boxing.svg';
import Icon67 from './interest/business.svg';
import Icon68 from './interest/business_advice_and_training.svg';
import Icon69 from './interest/business_leadership.svg';
import Icon70 from './interest/business_strategy_and_consultancy.svg';
import Icon71 from './interest/buying_a_home.svg';
import Icon72 from './interest/cars.svg';
import Icon73 from './interest/celebrity_gossip.svg';
import Icon74 from './interest/chess.svg';
import Icon75 from './interest/childrens_tv_shows.svg';
import Icon76 from './interest/classical_music.svg';
import Icon77 from './interest/climate_and_green_issues.svg';
import Icon78 from './interest/coffee.svg';
import Icon79 from './interest/combat_and_fighting_games.svg';
import Icon80 from './interest/comedy.svg';
import Icon81 from './interest/comic_books.svg';
import Icon82 from './interest/computing_and_software.svg';
import Icon83 from './interest/cooking.svg';
import Icon84 from './interest/cosmetics.svg';
import Icon85 from './interest/cosplay.svg';
import Icon86 from './interest/country_music.svg';
import Icon87 from './interest/coupons_and_saving_money.svg';
import Icon88 from './interest/crafts.svg';
import Icon89 from './interest/cricket.svg';
import Icon90 from './interest/crime_shows.svg';
import Icon91 from './interest/cruises.svg';
import Icon92 from './interest/cycling.svg';
import Icon93 from './interest/dance___ballet.svg';
import Icon94 from './interest/dance_music.svg';
import Icon95 from './interest/dance_or_ballet.svg';
import Icon96 from './interest/data.svg';
import Icon97 from './interest/data_protection.svg';
import Icon98 from './interest/dating_and_relationships.svg';
import Icon99 from './interest/design.svg';
import Icon100 from './interest/diy.svg';
import Icon101 from './interest/documentaries.svg';
import Icon102 from './interest/drama.svg';
import Icon103 from './interest/drawing.svg';
import Icon104 from './interest/eating_out.svg';
import Icon105 from './interest/economics.svg';
import Icon106 from './interest/electric_vehicles.svg';
import Icon107 from './interest/electronic_music.svg';
import Icon108 from './interest/electronics.svg';
import Icon109 from './interest/energy_drinks.svg';
import Icon110 from './interest/entertainment.svg';
import Icon111 from './interest/entrepreneurship_and_start_ups.svg';
import Icon112 from './interest/equestrian_sports.svg';
import Icon113 from './interest/esports.svg';
import Icon114 from './interest/ethnic_diversity.svg';
import Icon115 from './interest/extreme_sports.svg';
import Icon116 from './interest/family_and_parenting.svg';
import Icon117 from './interest/fantasy.svg';
import Icon118 from './interest/fashion.svg';
import Icon119 from './interest/fashion_affordable.svg';
import Icon120 from './interest/fashion_luxury.svg';
import Icon121 from './interest/fashion_premium.svg';
import Icon122 from './interest/fast_food.svg';
import Icon123 from './interest/fiction_books.svg';
import Icon124 from './interest/finance.svg';
import Icon125 from './interest/financial_technology.svg';
import Icon126 from './interest/finding_a_job.svg';
import Icon127 from './interest/fine_art.svg';
import Icon128 from './interest/fishing.svg';
import Icon129 from './interest/fitness.svg';
import Icon130 from './interest/food_and_drink.svg';
import Icon131 from './interest/food_waste.svg';
import Icon132 from './interest/football.svg';
import Icon133 from './interest/furniture.svg';
import Icon134 from './interest/gambling_and_casinos.svg';
import Icon135 from './interest/game_shows.svg';
import Icon136 from './interest/gaming.svg';
import Icon137 from './interest/gardening.svg';
import Icon138 from './interest/gender_diversity.svg';
import Icon139 from './interest/gluten_free.svg';
import Icon140 from './interest/golf.svg';
import Icon141 from './interest/gospel_music.svg';
import Icon142 from './interest/gymnastics.svg';
import Icon143 from './interest/haircare.svg';
import Icon144 from './interest/handbags.svg';
import Icon145 from './interest/health_and_fitness.svg';
import Icon146 from './interest/health_and_wellbeing.svg';
import Icon147 from './interest/healthy_eating.svg';
import Icon148 from './interest/hiking_and_trekking.svg';
import Icon149 from './interest/hip_hop_music.svg';
import Icon150 from './interest/historical_drama.svg';
import Icon151 from './interest/history.svg';
import Icon152 from './interest/hobbies.svg';
import Icon153 from './interest/holidays.svg';
import Icon154 from './interest/horror.svg';
import Icon155 from './interest/house_and_home.svg';
import Icon156 from './interest/human_and_civil_rights.svg';
import Icon157 from './interest/human_resources.svg';
import Icon158 from './interest/hunting_and_shooting.svg';
import Icon159 from './interest/insurance.svg';
import Icon160 from './interest/interior_design.svg';
import Icon161 from './interest/international_politics.svg';
import Icon162 from './interest/investment.svg';
import Icon163 from './interest/jazz_music.svg';
import Icon164 from './interest/jewellery_and_accessories.svg';
import Icon165 from './interest/law.svg';
import Icon166 from './interest/learning_and_education.svg';
import Icon167 from './interest/legal_drama.svg';
import Icon168 from './interest/lgbtq.svg';
import Icon169 from './interest/lifestyle.svg';
import Icon170 from './interest/lifestyle_tips.svg';
import Icon171 from './interest/live_music_and_festivals.svg';
import Icon172 from './interest/local_and_regional_news.svg';
import Icon173 from './interest/local_and_regional_politics.svg';
import Icon174 from './interest/magic.svg';
import Icon175 from './interest/male_grooming.svg';
import Icon176 from './interest/martial_arts.svg';
import Icon177 from './interest/maths.svg';
import Icon178 from './interest/medical_and_health_charities.svg';
import Icon179 from './interest/medical_drama.svg';
import Icon180 from './interest/mental_health.svg';
import Icon181 from './interest/metal_music.svg';
import Icon182 from './interest/military_and_national_security.svg';
import Icon183 from './interest/moba_games.svg';
import Icon184 from './interest/motor_sports.svg';
import Icon185 from './interest/motorbikes.svg';
import Icon186 from './interest/motoring.svg';
import Icon187 from './interest/museums.svg';
import Icon188 from './interest/music.svg';
import Icon189 from './interest/music_tv_shows.svg';
import Icon190 from './interest/musical_drama.svg';
import Icon191 from './interest/nailcare.svg';
import Icon192 from './interest/national_and_international_news.svg';
import Icon193 from './interest/national_politics.svg';
import Icon194 from './interest/nature_conservation.svg';
import Icon195 from './interest/netball.svg';
import Icon196 from './interest/news_and_current_affairs.svg';
import Icon197 from './interest/news_shows.svg';
import Icon198 from './interest/no_poverty.svg';
import Icon199 from './interest/ocean_conservation.svg';
import Icon200 from './interest/opera.svg';
import Icon201 from './interest/organic_food.svg';
import Icon202 from './interest/painting.svg';
import Icon203 from './interest/performing_arts.svg';
import Icon204 from './interest/period_drama.svg';
import Icon205 from './interest/personal_finance.svg';
import Icon206 from './interest/pets_and_animals.svg';
import Icon207 from './interest/philanthropy.svg';
import Icon208 from './interest/philosophy.svg';
import Icon209 from './interest/phones_and_communication.svg';
import Icon210 from './interest/photography.svg';
import Icon211 from './interest/piercing_and_tattoos.svg';
import Icon212 from './interest/pilates_yoga_and_meditation.svg';
import Icon213 from './interest/planet_protection.svg';
import Icon214 from './interest/plastic_free.svg';
import Icon215 from './interest/playing_music.svg';
import Icon216 from './interest/poetry.svg';
import Icon217 from './interest/politics_and_world_affairs.svg';
import Icon218 from './interest/popular_music.svg';
import Icon219 from './interest/pr_marketing_and_advertising.svg';
import Icon220 from './interest/property_and_construction.svg';
import Icon221 from './interest/public_healthcare.svg';
import Icon222 from './interest/racing_games.svg';
import Icon223 from './interest/racket_sports.svg';
import Icon224 from './interest/radio_shows.svg';
import Icon225 from './interest/randb_music.svg';
import Icon226 from './interest/rap_music.svg';
import Icon227 from './interest/reality_tv_shows.svg';
import Icon228 from './interest/recycling.svg';
import Icon229 from './interest/renewable_energy.svg';
import Icon230 from './interest/rock_music.svg';
import Icon231 from './interest/romance_drama.svg';
import Icon232 from './interest/rpg_games.svg';
import Icon233 from './interest/rugby_league.svg';
import Icon234 from './interest/rugby_union.svg';
import Icon235 from './interest/running_marathons_and_triathlons.svg';
import Icon236 from './interest/science.svg';
import Icon237 from './interest/science_fiction.svg';
import Icon238 from './interest/self_improvement.svg';
import Icon239 from './interest/shoes.svg';
import Icon240 from './interest/shooter_games.svg';
import Icon241 from './interest/shopping.svg';
import Icon242 from './interest/simulation_and_sandbox_games.svg';
import Icon243 from './interest/singing.svg';
import Icon244 from './interest/sitcom.svg';
import Icon245 from './interest/skincare.svg';
import Icon246 from './interest/sleep_optimisation.svg';
import Icon247 from './interest/small_business.svg';
import Icon248 from './interest/smoking_and_vaping.svg';
import Icon249 from './interest/soap_opera.svg';
import Icon250 from './interest/socialising.svg';
import Icon251 from './interest/soft_drinks.svg';
import Icon252 from './interest/soul_music.svg';
import Icon253 from './interest/space_and_astronomy.svg';
import Icon254 from './interest/spirits_and_liquor.svg';
import Icon255 from './interest/sports.svg';
import Icon256 from './interest/sports_games.svg';
import Icon257 from './interest/sports_nutrition.svg';
import Icon258 from './interest/sportswear_and_lifestyle.svg';
import Icon259 from './interest/strategy_games.svg';
import Icon260 from './interest/sustainability.svg';
import Icon261 from './interest/sweet_treats.svg';
import Icon262 from './interest/talent_shows.svg';
import Icon263 from './interest/talk_shows.svg';
import Icon264 from './interest/tea.svg';
import Icon265 from './interest/teaching.svg';
import Icon266 from './interest/technology.svg';
import Icon267 from './interest/teen_drama.svg';
import Icon268 from './interest/tennis.svg';
import Icon269 from './interest/the_great_outdoors.svg';
import Icon270 from './interest/theatre_and_stage_shows.svg';
import Icon271 from './interest/theme_parks.svg';
import Icon272 from './interest/thriller.svg';
import Icon273 from './interest/toys_and_board_games.svg';
import Icon274 from './interest/trading.svg';
import Icon275 from './interest/traffic_and_travel_news.svg';
import Icon276 from './interest/travel_and_leisure.svg';
import Icon277 from './interest/trucks.svg';
import Icon278 from './interest/tv_entertainment.svg';
import Icon279 from './interest/uk_politics.svg';
import Icon280 from './interest/uk_travel.svg';
import Icon281 from './interest/us_politics.svg';
import Icon282 from './interest/vegan.svg';
import Icon283 from './interest/vegetarian.svg';
import Icon284 from './interest/war_drama.svg';
import Icon285 from './interest/watches.svg';
import Icon286 from './interest/watching_movies.svg';
import Icon287 from './interest/water_sports.svg';
import Icon288 from './interest/weather_news.svg';
import Icon289 from './interest/weddings_and_getting_married.svg';
import Icon290 from './interest/weightloss.svg';
import Icon291 from './interest/wine.svg';
import Icon292 from './interest/winter_sports.svg';
import Icon293 from './interest/world_music.svg';
import Icon294 from './interest/wrestling.svg';
import Icon295 from './interest/writing.svg';
import Icon296 from './interest/zero_hunger.svg';
import Icon297 from './spend/airlines.svg';
import Icon298 from './spend/alcohol.svg';
import Icon299 from './spend/automotive_dealership.svg';
import Icon300 from './spend/bars_and_pubs.svg';
import Icon301 from './spend/bike_and_scooter_rental.svg';
import Icon302 from './spend/buses_coaches.svg';
import Icon303 from './spend/buy_now_pay_later.svg';
import Icon304 from './spend/car_rental.svg';
import Icon305 from './spend/cash_and_remittances.svg';
import Icon306 from './spend/charity.svg';
import Icon307 from './spend/childrens_clothing.svg';
import Icon308 from './spend/childrens_toys.svg';
import Icon309 from './spend/coffee_and_bakery.svg';
import Icon310 from './spend/convenience_store.svg';
import Icon311 from './spend/credit_card.svg';
import Icon312 from './spend/cruises.svg';
import Icon313 from './spend/education.svg';
import Icon314 from './spend/electric_vehicles.svg';
import Icon315 from './spend/electricals_and_technology.svg';
import Icon316 from './spend/energy.svg';
import Icon317 from './spend/entertainment_and_leisure.svg';
import Icon318 from './spend/experiences.svg';
import Icon319 from './spend/fast_food.svg';
import Icon320 from './spend/fast_grocery.svg';
import Icon321 from './spend/ferries.svg';
import Icon322 from './spend/finance_and_insurance.svg';
import Icon323 from './spend/fitness.svg';
import Icon324 from './spend/florist.svg';
import Icon325 from './spend/footwear.svg';
import Icon326 from './spend/fuel.svg';
import Icon327 from './spend/furniture_and_homewares.svg';
import Icon328 from './spend/gambling_and_betting.svg';
import Icon329 from './spend/general.svg';
import Icon330 from './spend/general_fashion.svg';
import Icon331 from './spend/general_insurance.svg';
import Icon332 from './spend/groceries.svg';
import Icon333 from './spend/health_and_beauty_budget.svg';
import Icon334 from './spend/health_and_beauty_high_end.svg';
import Icon335 from './spend/health_and_beauty_mid_tier.svg';
import Icon336 from './spend/hobbies_and_pursuits.svg';
import Icon337 from './spend/holiday_parking.svg';
import Icon338 from './spend/home_improvement.svg';
import Icon339 from './spend/hotels.svg';
import Icon340 from './spend/household_bills.svg';
import Icon341 from './spend/jewellery_and_accessories.svg';
import Icon342 from './spend/life_insurance.svg';
import Icon343 from './spend/local_council.svg';
import Icon344 from './spend/marketplace.svg';
import Icon345 from './spend/meal_boxes.svg';
import Icon346 from './spend/media_subscriptions.svg';
import Icon347 from './spend/menswear.svg';
import Icon348 from './spend/mobile_broadband_and_tv.svg';
import Icon349 from './spend/mortgage_and_rent.svg';
import Icon350 from './spend/niche_grocery.svg';
import Icon351 from './spend/opticians.svg';
import Icon352 from './spend/out_of_home.svg';
import Icon353 from './spend/parking.svg';
import Icon354 from './spend/paypal.svg';
import Icon355 from './spend/personal_loan.svg';
import Icon356 from './spend/pet_insurance.svg';
import Icon357 from './spend/pets.svg';
import Icon358 from './spend/railways.svg';
import Icon359 from './spend/restaurant_budget.svg';
import Icon360 from './spend/restaurant_high_end.svg';
import Icon361 from './spend/restaurant_mid_tier.svg';
import Icon362 from './spend/retail.svg';
import Icon363 from './spend/savings.svg';
import Icon364 from './spend/sports_and_leisure.svg';
import Icon365 from './spend/stationery_and_books.svg';
import Icon366 from './spend/supermarket.svg';
import Icon367 from './spend/takeaway_delivery.svg';
import Icon368 from './spend/tax.svg';
import Icon369 from './spend/taxi.svg';
import Icon370 from './spend/tolls_and_services.svg';
import Icon371 from './spend/travel_agent.svg';
import Icon372 from './spend/travel_holiday.svg';
import Icon373 from './spend/universal_finance_provider.svg';
import Icon374 from './spend/universal_retailer.svg';
import Icon375 from './spend/vehicle_maintenance.svg';
import Icon376 from './spend/vehicle_transport.svg';
import Icon377 from './spend/water.svg';
import Icon378 from './spend/womenswear.svg';
import Icon379 from './tv/action.svg';
import Icon380 from './tv/adventure.svg';
import Icon381 from './tv/animated.svg';
import Icon382 from './tv/comedy.svg';
import Icon383 from './tv/crime.svg';
import Icon384 from './tv/documentary.svg';
import Icon385 from './tv/drama.svg';
import Icon386 from './tv/entertainment.svg';
import Icon387 from './tv/family.svg';
import Icon388 from './tv/fantasy.svg';
import Icon389 from './tv/game_show.svg';
import Icon390 from './tv/health_and_medicine.svg';
import Icon391 from './tv/horror.svg';
import Icon392 from './tv/informational.svg';
import Icon393 from './tv/investigative.svg';
import Icon394 from './tv/movie.svg';
import Icon395 from './tv/music.svg';
import Icon396 from './tv/mystery.svg';
import Icon397 from './tv/nature.svg';
import Icon398 from './tv/news.svg';
import Icon399 from './tv/profile.svg';
import Icon400 from './tv/reality.svg';
import Icon401 from './tv/romance.svg';
import Icon402 from './tv/science_and_technology.svg';
import Icon403 from './tv/science_fiction.svg';
import Icon404 from './tv/show.svg';
import Icon405 from './tv/sports.svg';
import Icon406 from './tv/thriller_and_suspense.svg';
import DefaultIcon from './default.svg'; // default fallback icon

export const iconMap = {
  'cause': {
    'animal_welfare': Icon0,
    'anti_racism': Icon1,
    'armed_forces_charities': Icon2,
    'autism': Icon3,
    'bird_protection': Icon4,
    'cancer_charities': Icon5,
    'charity_regulation': Icon6,
    'childrens_charities': Icon7,
    'climate_change': Icon8,
    'countryside': Icon9,
    'diabetes_charities': Icon10,
    'disability': Icon11,
    'dog_welfare': Icon12,
    'fairtrade': Icon13,
    'feminism': Icon14,
    'gardens': Icon15,
    'homelessness': Icon16,
    'human_rights': Icon17,
    'legal_rights': Icon18,
    'lgbtq_diversity': Icon19,
    'lifeboats_and_coastguards': Icon20,
    'mental_health': Icon21,
    'ms_charities': Icon22,
    'national_development': Icon23,
    'nature_protection': Icon24,
    'ocean_protection': Icon25,
    'old_people_supporters': Icon26,
    'pet_protection': Icon27,
    'planet_protection': Icon28,
    'recycling_and_plastic_free': Icon29,
    'refugees_and_equality': Icon30,
    'renewable_energy': Icon31,
    'the_environment': Icon32,
    'tv_fundraising': Icon33,
    'vegan_lifestyle': Icon34,
    'veganism': Icon35,
    'world_aid': Icon36,
    'world_wildlife': Icon37,
  },
  '': {
    'default': Icon38,
  },
  'interest': {
    'academia': Icon39,
    'accountancy': Icon40,
    'action': Icon41,
    'action_and_adventure_games': Icon42,
    'alcohol': Icon43,
    'american_football': Icon44,
    'animal_charities': Icon45,
    'animation_and_cartoons': Icon46,
    'anime': Icon47,
    'antiques': Icon48,
    'architecture': Icon49,
    'art': Icon50,
    'art_and_design': Icon51,
    'asian_pop_music': Icon52,
    'athletics': Icon53,
    'award_shows': Icon54,
    'baking': Icon55,
    'baseball': Icon56,
    'basketball': Icon57,
    'beauty': Icon58,
    'beer_and_cider': Icon59,
    'bird_and_wildlife_spotting': Icon60,
    'blues_music': Icon61,
    'boats': Icon62,
    'body_building_and_weightlifting': Icon63,
    'bollywood': Icon64,
    'books_and_literature': Icon65,
    'boxing': Icon66,
    'business': Icon67,
    'business_advice_and_training': Icon68,
    'business_leadership': Icon69,
    'business_strategy_and_consultancy': Icon70,
    'buying_a_home': Icon71,
    'cars': Icon72,
    'celebrity_gossip': Icon73,
    'chess': Icon74,
    'childrens_tv_shows': Icon75,
    'classical_music': Icon76,
    'climate_and_green_issues': Icon77,
    'coffee': Icon78,
    'combat_and_fighting_games': Icon79,
    'comedy': Icon80,
    'comic_books': Icon81,
    'computing_and_software': Icon82,
    'cooking': Icon83,
    'cosmetics': Icon84,
    'cosplay': Icon85,
    'country_music': Icon86,
    'coupons_and_saving_money': Icon87,
    'crafts': Icon88,
    'cricket': Icon89,
    'crime_shows': Icon90,
    'cruises': Icon91,
    'cycling': Icon92,
    'dance___ballet': Icon93,
    'dance_music': Icon94,
    'dance_or_ballet': Icon95,
    'data': Icon96,
    'data_protection': Icon97,
    'dating_and_relationships': Icon98,
    'design': Icon99,
    'diy': Icon100,
    'documentaries': Icon101,
    'drama': Icon102,
    'drawing': Icon103,
    'eating_out': Icon104,
    'economics': Icon105,
    'electric_vehicles': Icon106,
    'electronic_music': Icon107,
    'electronics': Icon108,
    'energy_drinks': Icon109,
    'entertainment': Icon110,
    'entrepreneurship_and_start_ups': Icon111,
    'equestrian_sports': Icon112,
    'esports': Icon113,
    'ethnic_diversity': Icon114,
    'extreme_sports': Icon115,
    'family_and_parenting': Icon116,
    'fantasy': Icon117,
    'fashion': Icon118,
    'fashion_affordable': Icon119,
    'fashion_luxury': Icon120,
    'fashion_premium': Icon121,
    'fast_food': Icon122,
    'fiction_books': Icon123,
    'finance': Icon124,
    'financial_technology': Icon125,
    'finding_a_job': Icon126,
    'fine_art': Icon127,
    'fishing': Icon128,
    'fitness': Icon129,
    'food_and_drink': Icon130,
    'food_waste': Icon131,
    'football': Icon132,
    'furniture': Icon133,
    'gambling_and_casinos': Icon134,
    'game_shows': Icon135,
    'gaming': Icon136,
    'gardening': Icon137,
    'gender_diversity': Icon138,
    'gluten_free': Icon139,
    'golf': Icon140,
    'gospel_music': Icon141,
    'gymnastics': Icon142,
    'haircare': Icon143,
    'handbags': Icon144,
    'health_and_fitness': Icon145,
    'health_and_wellbeing': Icon146,
    'healthy_eating': Icon147,
    'hiking_and_trekking': Icon148,
    'hip_hop_music': Icon149,
    'historical_drama': Icon150,
    'history': Icon151,
    'hobbies': Icon152,
    'holidays': Icon153,
    'horror': Icon154,
    'house_and_home': Icon155,
    'human_and_civil_rights': Icon156,
    'human_resources': Icon157,
    'hunting_and_shooting': Icon158,
    'insurance': Icon159,
    'interior_design': Icon160,
    'international_politics': Icon161,
    'investment': Icon162,
    'jazz_music': Icon163,
    'jewellery_and_accessories': Icon164,
    'law': Icon165,
    'learning_and_education': Icon166,
    'legal_drama': Icon167,
    'lgbtq': Icon168,
    'lifestyle': Icon169,
    'lifestyle_tips': Icon170,
    'live_music_and_festivals': Icon171,
    'local_and_regional_news': Icon172,
    'local_and_regional_politics': Icon173,
    'magic': Icon174,
    'male_grooming': Icon175,
    'martial_arts': Icon176,
    'maths': Icon177,
    'medical_and_health_charities': Icon178,
    'medical_drama': Icon179,
    'mental_health': Icon180,
    'metal_music': Icon181,
    'military_and_national_security': Icon182,
    'moba_games': Icon183,
    'motor_sports': Icon184,
    'motorbikes': Icon185,
    'motoring': Icon186,
    'museums': Icon187,
    'music': Icon188,
    'music_tv_shows': Icon189,
    'musical_drama': Icon190,
    'nailcare': Icon191,
    'national_and_international_news': Icon192,
    'national_politics': Icon193,
    'nature_conservation': Icon194,
    'netball': Icon195,
    'news_and_current_affairs': Icon196,
    'news_shows': Icon197,
    'no_poverty': Icon198,
    'ocean_conservation': Icon199,
    'opera': Icon200,
    'organic_food': Icon201,
    'painting': Icon202,
    'performing_arts': Icon203,
    'period_drama': Icon204,
    'personal_finance': Icon205,
    'pets_and_animals': Icon206,
    'philanthropy': Icon207,
    'philosophy': Icon208,
    'phones_and_communication': Icon209,
    'photography': Icon210,
    'piercing_and_tattoos': Icon211,
    'pilates_yoga_and_meditation': Icon212,
    'planet_protection': Icon213,
    'plastic_free': Icon214,
    'playing_music': Icon215,
    'poetry': Icon216,
    'politics_and_world_affairs': Icon217,
    'popular_music': Icon218,
    'pr_marketing_and_advertising': Icon219,
    'property_and_construction': Icon220,
    'public_healthcare': Icon221,
    'racing_games': Icon222,
    'racket_sports': Icon223,
    'radio_shows': Icon224,
    'randb_music': Icon225,
    'rap_music': Icon226,
    'reality_tv_shows': Icon227,
    'recycling': Icon228,
    'renewable_energy': Icon229,
    'rock_music': Icon230,
    'romance_drama': Icon231,
    'rpg_games': Icon232,
    'rugby_league': Icon233,
    'rugby_union': Icon234,
    'running_marathons_and_triathlons': Icon235,
    'science': Icon236,
    'science_fiction': Icon237,
    'self_improvement': Icon238,
    'shoes': Icon239,
    'shooter_games': Icon240,
    'shopping': Icon241,
    'simulation_and_sandbox_games': Icon242,
    'singing': Icon243,
    'sitcom': Icon244,
    'skincare': Icon245,
    'sleep_optimisation': Icon246,
    'small_business': Icon247,
    'smoking_and_vaping': Icon248,
    'soap_opera': Icon249,
    'socialising': Icon250,
    'soft_drinks': Icon251,
    'soul_music': Icon252,
    'space_and_astronomy': Icon253,
    'spirits_and_liquor': Icon254,
    'sports': Icon255,
    'sports_games': Icon256,
    'sports_nutrition': Icon257,
    'sportswear_and_lifestyle': Icon258,
    'strategy_games': Icon259,
    'sustainability': Icon260,
    'sweet_treats': Icon261,
    'talent_shows': Icon262,
    'talk_shows': Icon263,
    'tea': Icon264,
    'teaching': Icon265,
    'technology': Icon266,
    'teen_drama': Icon267,
    'tennis': Icon268,
    'the_great_outdoors': Icon269,
    'theatre_and_stage_shows': Icon270,
    'theme_parks': Icon271,
    'thriller': Icon272,
    'toys_and_board_games': Icon273,
    'trading': Icon274,
    'traffic_and_travel_news': Icon275,
    'travel_and_leisure': Icon276,
    'trucks': Icon277,
    'tv_entertainment': Icon278,
    'uk_politics': Icon279,
    'uk_travel': Icon280,
    'us_politics': Icon281,
    'vegan': Icon282,
    'vegetarian': Icon283,
    'war_drama': Icon284,
    'watches': Icon285,
    'watching_movies': Icon286,
    'water_sports': Icon287,
    'weather_news': Icon288,
    'weddings_and_getting_married': Icon289,
    'weightloss': Icon290,
    'wine': Icon291,
    'winter_sports': Icon292,
    'world_music': Icon293,
    'wrestling': Icon294,
    'writing': Icon295,
    'zero_hunger': Icon296,
  },
  'spend': {
    'airlines': Icon297,
    'alcohol': Icon298,
    'automotive_dealership': Icon299,
    'bars_and_pubs': Icon300,
    'bike_and_scooter_rental': Icon301,
    'buses_coaches': Icon302,
    'buy_now_pay_later': Icon303,
    'car_rental': Icon304,
    'cash_and_remittances': Icon305,
    'charity': Icon306,
    'childrens_clothing': Icon307,
    'childrens_toys': Icon308,
    'coffee_and_bakery': Icon309,
    'convenience_store': Icon310,
    'credit_card': Icon311,
    'cruises': Icon312,
    'education': Icon313,
    'electric_vehicles': Icon314,
    'electricals_and_technology': Icon315,
    'energy': Icon316,
    'entertainment_and_leisure': Icon317,
    'experiences': Icon318,
    'fast_food': Icon319,
    'fast_grocery': Icon320,
    'ferries': Icon321,
    'finance_and_insurance': Icon322,
    'fitness': Icon323,
    'florist': Icon324,
    'footwear': Icon325,
    'fuel': Icon326,
    'furniture_and_homewares': Icon327,
    'gambling_and_betting': Icon328,
    'general': Icon329,
    'general_fashion': Icon330,
    'general_insurance': Icon331,
    'groceries': Icon332,
    'health_and_beauty_budget': Icon333,
    'health_and_beauty_high_end': Icon334,
    'health_and_beauty_mid_tier': Icon335,
    'hobbies_and_pursuits': Icon336,
    'holiday_parking': Icon337,
    'home_improvement': Icon338,
    'hotels': Icon339,
    'household_bills': Icon340,
    'jewellery_and_accessories': Icon341,
    'life_insurance': Icon342,
    'local_council': Icon343,
    'marketplace': Icon344,
    'meal_boxes': Icon345,
    'media_subscriptions': Icon346,
    'menswear': Icon347,
    'mobile_broadband_and_tv': Icon348,
    'mortgage_and_rent': Icon349,
    'niche_grocery': Icon350,
    'opticians': Icon351,
    'out_of_home': Icon352,
    'parking': Icon353,
    'paypal': Icon354,
    'personal_loan': Icon355,
    'pet_insurance': Icon356,
    'pets': Icon357,
    'railways': Icon358,
    'restaurant_budget': Icon359,
    'restaurant_high_end': Icon360,
    'restaurant_mid_tier': Icon361,
    'retail': Icon362,
    'savings': Icon363,
    'sports_and_leisure': Icon364,
    'stationery_and_books': Icon365,
    'supermarket': Icon366,
    'takeaway_delivery': Icon367,
    'tax': Icon368,
    'taxi': Icon369,
    'tolls_and_services': Icon370,
    'travel_agent': Icon371,
    'travel_holiday': Icon372,
    'universal_finance_provider': Icon373,
    'universal_retailer': Icon374,
    'vehicle_maintenance': Icon375,
    'vehicle_transport': Icon376,
    'water': Icon377,
    'womenswear': Icon378,
  },
  'tv': {
    'action': Icon379,
    'adventure': Icon380,
    'animated': Icon381,
    'comedy': Icon382,
    'crime': Icon383,
    'documentary': Icon384,
    'drama': Icon385,
    'entertainment': Icon386,
    'family': Icon387,
    'fantasy': Icon388,
    'game_show': Icon389,
    'health_and_medicine': Icon390,
    'horror': Icon391,
    'informational': Icon392,
    'investigative': Icon393,
    'movie': Icon394,
    'music': Icon395,
    'mystery': Icon396,
    'nature': Icon397,
    'news': Icon398,
    'profile': Icon399,
    'reality': Icon400,
    'romance': Icon401,
    'science_and_technology': Icon402,
    'science_fiction': Icon403,
    'show': Icon404,
    'sports': Icon405,
    'thriller_and_suspense': Icon406,
  },
} as const;

export function getIconComponent(
  category: string,
  name: string
): React.FunctionComponent<React.SVGProps<SVGSVGElement>> {
  
  const categoryMap = iconMap[category as keyof typeof iconMap]
  
  if (categoryMap && name in categoryMap) {
    return categoryMap[name as keyof typeof categoryMap];
  }
  
  // console.warn("⚠️ Icon not found: " + category + "/" + name + ", using default.");
  return DefaultIcon;
}
